function setupExpandServices() {
  // Allow user to expand service block
  const services = document.querySelectorAll('.service')
  for (const service of services) {
    service.addEventListener('click', () => {
      service.querySelector('.service-intro').classList.toggle('hidden')
      service.querySelector('.service-text').classList.toggle('hidden')
    })
  }
}

window.addEventListener('DOMContentLoaded', setupExpandServices)